var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSpinner)?_c('div',{staticClass:"spinner"},[_c('FlamePreloader',{attrs:{"compact":true,"size":100}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }